/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as restaurantRestaurantShellLayoutRouteImport } from './routes/restaurant/RestaurantShellLayout'
import { Route as connectAgentConnectAgentPageRouteImport } from './routes/connect-agent/ConnectAgentPage'
import { Route as adminAdminLayoutRouteImport } from './routes/admin/AdminLayout'
import { Route as RootRedirectRouteImport } from './routes/RootRedirect'
import { Route as restaurantRestaurantLayoutRouteImport } from './routes/restaurant/RestaurantLayout'
import { Route as MenuVersionDiffPageRouteImport } from './routes/MenuVersionDiffPage'
import { Route as adminRestaurantsRestaurantListPageRouteImport } from './routes/admin/restaurants/RestaurantListPage'
import { Route as adminPhoneCallsAdminPhoneCallListPageRouteImport } from './routes/admin/phone-calls/AdminPhoneCallListPage'
import { Route as adminFeatureFlagsFeatureFlagListPageRouteImport } from './routes/admin/feature-flags/FeatureFlagListPage'
import { Route as adminConversationsConversationsLayoutRouteImport } from './routes/admin/conversations/ConversationsLayout'
import { Route as adminAppUpdatesAppUpdatesPageRouteImport } from './routes/admin/app-updates/AppUpdatesPage'
import { Route as restaurantSelectRestaurantPageRouteImport } from './routes/restaurant/SelectRestaurantPage'
import { Route as adminAdminRootRedirectRouteImport } from './routes/admin/AdminRootRedirect'
import { Route as restaurantSettingsSettingsLayoutRouteImport } from './routes/restaurant/settings/SettingsLayout'
import { Route as restaurantRegisterClosuresRegisterClosuresPageRouteImport } from './routes/restaurant/register-closures/RegisterClosuresPage'
import { Route as restaurantPrintJobsPrintJobsPageRouteImport } from './routes/restaurant/print-jobs/PrintJobsPage'
import { Route as restaurantMenuMenuLayoutRouteImport } from './routes/restaurant/menu/MenuLayout'
import { Route as restaurantDayReportsDayReportsPageRouteImport } from './routes/restaurant/day-reports/DayReportsPage'
import { Route as adminRemoteCommandsRemoteCommandDetailsPageRouteImport } from './routes/admin/remote-commands/RemoteCommandDetailsPage'
import { Route as adminPushNotificationsPushNotificationDetailsPageRouteImport } from './routes/admin/push-notifications/PushNotificationDetailsPage'
import { Route as adminOrdersAdminOrderDetailsPageRouteImport } from './routes/admin/orders/AdminOrderDetailsPage'
import { Route as adminLogsAdminLogDetailsPageRouteImport } from './routes/admin/logs/AdminLogDetailsPage'
import { Route as adminIpadsAdminIPadDetailsPageRouteImport } from './routes/admin/ipads/AdminIPadDetailsPage'
import { Route as adminConversationsConversationDetailsPageRouteImport } from './routes/admin/conversations/ConversationDetailsPage'
import { Route as adminArticlesArticleEditPageRouteImport } from './routes/admin/articles/ArticleEditPage'
import { Route as adminStandalonePrintersStandalonePrinterListPageRouteImport } from './routes/admin/standalone-printers/StandalonePrinterListPage'
import { Route as adminRemoteCommandsRemoteCommandListPageRouteImport } from './routes/admin/remote-commands/RemoteCommandListPage'
import { Route as adminPushNotificationsPushNotificationListPageRouteImport } from './routes/admin/push-notifications/PushNotificationListPage'
import { Route as adminOrdersAdminOrderListPageRouteImport } from './routes/admin/orders/AdminOrderListPage'
import { Route as adminLogsAdminLogListPageRouteImport } from './routes/admin/logs/AdminLogListPage'
import { Route as adminIpadsAdminIPadListPageRouteImport } from './routes/admin/ipads/AdminIPadListPage'
import { Route as adminConversationsConversationListPageRouteImport } from './routes/admin/conversations/ConversationListPage'
import { Route as adminArticlesArticleListPageRouteImport } from './routes/admin/articles/ArticleListPage'
import { Route as restaurantSettingsWebsiteConfigWebsiteConfigPageRouteImport } from './routes/restaurant/settings/website-config/WebsiteConfigPage'
import { Route as restaurantSettingsWebsiteAddressWebsiteAddressPageRouteImport } from './routes/restaurant/settings/website-address/WebsiteAddressPage'
import { Route as restaurantSettingsUsersRestaurantUserListPageRouteImport } from './routes/restaurant/settings/users/RestaurantUserListPage'
import { Route as restaurantSettingsStripeStripePageRouteImport } from './routes/restaurant/settings/stripe/StripePage'
import { Route as restaurantSettingsIntegrationsSquareSquarePageRouteImport } from './routes/restaurant/settings/integrations/square/SquarePage'
import { Route as restaurantSettingsServiceHoursServiceHoursPageRouteImport } from './routes/restaurant/settings/service-hours/ServiceHoursPage'
import { Route as restaurantSettingsPosPrintersPosPrintersPageRouteImport } from './routes/restaurant/settings/pos-printers/PosPrintersPage'
import { Route as restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRouteImport } from './routes/restaurant/settings/pos-price-adjustments/PosPriceAdjustmentsPage'
import { Route as restaurantSettingsPosPasscodesPosPasscodesPageRouteImport } from './routes/restaurant/settings/pos-passcodes/PosPasscodesPage'
import { Route as restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport } from './routes/restaurant/settings/platform-settings/PlatformSettingsPage'
import { Route as restaurantSettingsMobileAppConfigMobileAppConfigPageRouteImport } from './routes/restaurant/settings/mobile-app-config/MobileAppConfigPage'
import { Route as restaurantSettingsLoyaltyCardLoyaltyCardPageRouteImport } from './routes/restaurant/settings/loyalty-card/LoyaltyCardPage'
import { Route as restaurantSettingsGeneralSettingsGeneralSettingsPageRouteImport } from './routes/restaurant/settings/general-settings/GeneralSettingsPage'
import { Route as restaurantSettingsFloorPlansFloorPlansPageRouteImport } from './routes/restaurant/settings/floor-plans/FloorPlansPage'
import { Route as restaurantSettingsFeaturesFeaturesPageRouteImport } from './routes/restaurant/settings/features/FeaturesPage'
import { Route as restaurantSettingsFeatureFlagsFeatureFlagsPageRouteImport } from './routes/restaurant/settings/feature-flags/FeatureFlagsPage'
import { Route as restaurantSettingsDiscountCodesDiscountCodeListPageRouteImport } from './routes/restaurant/settings/discount-codes/DiscountCodeListPage'
import { Route as restaurantSettingsDeliveryDeliveryPageRouteImport } from './routes/restaurant/settings/delivery/DeliveryPage'
import { Route as restaurantSettingsAiAgentsAiAgentsPageRouteImport } from './routes/restaurant/settings/ai-agents/AiAgentsPage'
import { Route as restaurantPhoneCallsPhoneCallDetailsPageRouteImport } from './routes/restaurant/phone-calls/PhoneCallDetailsPage'
import { Route as restaurantOrdersOrderDetailsPageRouteImport } from './routes/restaurant/orders/OrderDetailsPage'
import { Route as restaurantMenuOverviewMenuOverviewPageRouteImport } from './routes/restaurant/menu/overview/MenuOverviewPage'
import { Route as restaurantMenuModifiersModifierListPageRouteImport } from './routes/restaurant/menu/modifiers/ModifierListPage'
import { Route as restaurantMenuMenuItemsMenuItemListPageRouteImport } from './routes/restaurant/menu/menu-items/MenuItemListPage'
import { Route as restaurantMenuCategoriesCategoryListPageRouteImport } from './routes/restaurant/menu/categories/CategoryListPage'
import { Route as restaurantLogsLogDetailsPageRouteImport } from './routes/restaurant/logs/LogDetailsPage'
import { Route as restaurantCustomersCustomerDetailsPageRouteImport } from './routes/restaurant/customers/CustomerDetailsPage'
import { Route as adminStandalonePrintersStandalonePrinterEmulatorPageRouteImport } from './routes/admin/standalone-printers/StandalonePrinterEmulatorPage'
import { Route as adminLinklyLinklySessionDetailsPageRouteImport } from './routes/admin/linkly/LinklySessionDetailsPage'
import { Route as adminLinklyLinklyRequestDetailsPageRouteImport } from './routes/admin/linkly/LinklyRequestDetailsPage'
import { Route as adminLinklyLinklyDeviceDetailsPageRouteImport } from './routes/admin/linkly/LinklyDeviceDetailsPage'
import { Route as restaurantPhoneCallsPhoneCallListPageRouteImport } from './routes/restaurant/phone-calls/PhoneCallListPage'
import { Route as restaurantOrdersOrderListPageRouteImport } from './routes/restaurant/orders/OrderListPage'
import { Route as restaurantLogsLogListPageRouteImport } from './routes/restaurant/logs/LogListPage'
import { Route as restaurantCustomersCustomerListPageRouteImport } from './routes/restaurant/customers/CustomerListPage'
import { Route as adminLinklyLinklyDeviceListPageRouteImport } from './routes/admin/linkly/LinklyDeviceListPage'
import { Route as restaurantSettingsIpadsIPadDetailsPageRouteImport } from './routes/restaurant/settings/ipads/IPadDetailsPage'
import { Route as restaurantMenuMenuVersionsMenuVersionListPageRouteImport } from './routes/restaurant/menu/menu-versions/MenuVersionListPage'
import { Route as restaurantSettingsIpadsIPadListPageRouteImport } from './routes/restaurant/settings/ipads/IPadListPage'

const restaurantRestaurantShellLayoutRoute =
  restaurantRestaurantShellLayoutRouteImport.update({
    id: '/r',
    path: '/r',
    getParentRoute: () => rootRouteImport,
  } as any)
const connectAgentConnectAgentPageRoute =
  connectAgentConnectAgentPageRouteImport.update({
    id: '/connect-agent',
    path: '/connect-agent',
    getParentRoute: () => rootRouteImport,
  } as any)
const adminAdminLayoutRoute = adminAdminLayoutRouteImport.update({
  id: '/a',
  path: '/a',
  getParentRoute: () => rootRouteImport,
} as any)
const RootRedirectRoute = RootRedirectRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const restaurantRestaurantLayoutRoute =
  restaurantRestaurantLayoutRouteImport.update({
    id: '/$restaurantId',
    path: '/$restaurantId',
    getParentRoute: () => restaurantRestaurantShellLayoutRoute,
  } as any)
const MenuVersionDiffPageRoute = MenuVersionDiffPageRouteImport.update({
  id: '/menu-versions/$menuVersionId',
  path: '/menu-versions/$menuVersionId',
  getParentRoute: () => rootRouteImport,
} as any)
const adminRestaurantsRestaurantListPageRoute =
  adminRestaurantsRestaurantListPageRouteImport.update({
    id: '/restaurants',
    path: '/restaurants',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminPhoneCallsAdminPhoneCallListPageRoute =
  adminPhoneCallsAdminPhoneCallListPageRouteImport.update({
    id: '/phone-calls',
    path: '/phone-calls',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminFeatureFlagsFeatureFlagListPageRoute =
  adminFeatureFlagsFeatureFlagListPageRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminConversationsConversationsLayoutRoute =
  adminConversationsConversationsLayoutRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminAppUpdatesAppUpdatesPageRoute =
  adminAppUpdatesAppUpdatesPageRouteImport.update({
    id: '/app-updates',
    path: '/app-updates',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const restaurantSelectRestaurantPageRoute =
  restaurantSelectRestaurantPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => restaurantRestaurantShellLayoutRoute,
  } as any)
const adminAdminRootRedirectRoute = adminAdminRootRedirectRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminAdminLayoutRoute,
} as any)
const restaurantSettingsSettingsLayoutRoute =
  restaurantSettingsSettingsLayoutRouteImport.update({
    id: '/s',
    path: '/s',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantRegisterClosuresRegisterClosuresPageRoute =
  restaurantRegisterClosuresRegisterClosuresPageRouteImport.update({
    id: '/register-closures',
    path: '/register-closures',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantPrintJobsPrintJobsPageRoute =
  restaurantPrintJobsPrintJobsPageRouteImport.update({
    id: '/print-jobs',
    path: '/print-jobs',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantMenuMenuLayoutRoute =
  restaurantMenuMenuLayoutRouteImport.update({
    id: '/menu',
    path: '/menu',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantDayReportsDayReportsPageRoute =
  restaurantDayReportsDayReportsPageRouteImport.update({
    id: '/day-reports',
    path: '/day-reports',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const adminRemoteCommandsRemoteCommandDetailsPageRoute =
  adminRemoteCommandsRemoteCommandDetailsPageRouteImport.update({
    id: '/remote-commands/$commandId',
    path: '/remote-commands/$commandId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminPushNotificationsPushNotificationDetailsPageRoute =
  adminPushNotificationsPushNotificationDetailsPageRouteImport.update({
    id: '/push-notifications/$notificationId',
    path: '/push-notifications/$notificationId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminOrdersAdminOrderDetailsPageRoute =
  adminOrdersAdminOrderDetailsPageRouteImport.update({
    id: '/orders/$orderUuid',
    path: '/orders/$orderUuid',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminLogsAdminLogDetailsPageRoute =
  adminLogsAdminLogDetailsPageRouteImport.update({
    id: '/logs/$eventId',
    path: '/logs/$eventId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminIpadsAdminIPadDetailsPageRoute =
  adminIpadsAdminIPadDetailsPageRouteImport.update({
    id: '/ipads/$deviceId',
    path: '/ipads/$deviceId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminConversationsConversationDetailsPageRoute =
  adminConversationsConversationDetailsPageRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => adminConversationsConversationsLayoutRoute,
  } as any)
const adminArticlesArticleEditPageRoute =
  adminArticlesArticleEditPageRouteImport.update({
    id: '/articles/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminStandalonePrintersStandalonePrinterListPageRoute =
  adminStandalonePrintersStandalonePrinterListPageRouteImport.update({
    id: '/standalone-printers/',
    path: '/standalone-printers/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminRemoteCommandsRemoteCommandListPageRoute =
  adminRemoteCommandsRemoteCommandListPageRouteImport.update({
    id: '/remote-commands/',
    path: '/remote-commands/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminPushNotificationsPushNotificationListPageRoute =
  adminPushNotificationsPushNotificationListPageRouteImport.update({
    id: '/push-notifications/',
    path: '/push-notifications/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminOrdersAdminOrderListPageRoute =
  adminOrdersAdminOrderListPageRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminLogsAdminLogListPageRoute =
  adminLogsAdminLogListPageRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminIpadsAdminIPadListPageRoute =
  adminIpadsAdminIPadListPageRouteImport.update({
    id: '/ipads/',
    path: '/ipads/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminConversationsConversationListPageRoute =
  adminConversationsConversationListPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminConversationsConversationsLayoutRoute,
  } as any)
const adminArticlesArticleListPageRoute =
  adminArticlesArticleListPageRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const restaurantSettingsWebsiteConfigWebsiteConfigPageRoute =
  restaurantSettingsWebsiteConfigWebsiteConfigPageRouteImport.update({
    id: '/website-config',
    path: '/website-config',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsWebsiteAddressWebsiteAddressPageRoute =
  restaurantSettingsWebsiteAddressWebsiteAddressPageRouteImport.update({
    id: '/website-address',
    path: '/website-address',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsUsersRestaurantUserListPageRoute =
  restaurantSettingsUsersRestaurantUserListPageRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsStripeStripePageRoute =
  restaurantSettingsStripeStripePageRouteImport.update({
    id: '/stripe',
    path: '/stripe',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsIntegrationsSquareSquarePageRoute =
  restaurantSettingsIntegrationsSquareSquarePageRouteImport.update({
    id: '/square',
    path: '/square',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsServiceHoursServiceHoursPageRoute =
  restaurantSettingsServiceHoursServiceHoursPageRouteImport.update({
    id: '/service-hours',
    path: '/service-hours',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsPosPrintersPosPrintersPageRoute =
  restaurantSettingsPosPrintersPosPrintersPageRouteImport.update({
    id: '/pos-printers',
    path: '/pos-printers',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute =
  restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRouteImport.update(
    {
      id: '/pos-price-adjustments',
      path: '/pos-price-adjustments',
      getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
    } as any,
  )
const restaurantSettingsPosPasscodesPosPasscodesPageRoute =
  restaurantSettingsPosPasscodesPosPasscodesPageRouteImport.update({
    id: '/pos-passcodes',
    path: '/pos-passcodes',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsPlatformSettingsPlatformSettingsPageRoute =
  restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport.update({
    id: '/platform-settings',
    path: '/platform-settings',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsMobileAppConfigMobileAppConfigPageRoute =
  restaurantSettingsMobileAppConfigMobileAppConfigPageRouteImport.update({
    id: '/mobile-app-config',
    path: '/mobile-app-config',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsLoyaltyCardLoyaltyCardPageRoute =
  restaurantSettingsLoyaltyCardLoyaltyCardPageRouteImport.update({
    id: '/loyalty-card',
    path: '/loyalty-card',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsGeneralSettingsGeneralSettingsPageRoute =
  restaurantSettingsGeneralSettingsGeneralSettingsPageRouteImport.update({
    id: '/general-settings',
    path: '/general-settings',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsFloorPlansFloorPlansPageRoute =
  restaurantSettingsFloorPlansFloorPlansPageRouteImport.update({
    id: '/floor-plans',
    path: '/floor-plans',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsFeaturesFeaturesPageRoute =
  restaurantSettingsFeaturesFeaturesPageRouteImport.update({
    id: '/features',
    path: '/features',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsFeatureFlagsFeatureFlagsPageRoute =
  restaurantSettingsFeatureFlagsFeatureFlagsPageRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsDiscountCodesDiscountCodeListPageRoute =
  restaurantSettingsDiscountCodesDiscountCodeListPageRouteImport.update({
    id: '/discount-codes',
    path: '/discount-codes',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsDeliveryDeliveryPageRoute =
  restaurantSettingsDeliveryDeliveryPageRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantSettingsAiAgentsAiAgentsPageRoute =
  restaurantSettingsAiAgentsAiAgentsPageRouteImport.update({
    id: '/ai-agents',
    path: '/ai-agents',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantPhoneCallsPhoneCallDetailsPageRoute =
  restaurantPhoneCallsPhoneCallDetailsPageRouteImport.update({
    id: '/phone-calls/$callId',
    path: '/phone-calls/$callId',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantOrdersOrderDetailsPageRoute =
  restaurantOrdersOrderDetailsPageRouteImport.update({
    id: '/orders/$orderUuid',
    path: '/orders/$orderUuid',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantMenuOverviewMenuOverviewPageRoute =
  restaurantMenuOverviewMenuOverviewPageRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => restaurantMenuMenuLayoutRoute,
  } as any)
const restaurantMenuModifiersModifierListPageRoute =
  restaurantMenuModifiersModifierListPageRouteImport.update({
    id: '/modifiers',
    path: '/modifiers',
    getParentRoute: () => restaurantMenuMenuLayoutRoute,
  } as any)
const restaurantMenuMenuItemsMenuItemListPageRoute =
  restaurantMenuMenuItemsMenuItemListPageRouteImport.update({
    id: '/menu-items',
    path: '/menu-items',
    getParentRoute: () => restaurantMenuMenuLayoutRoute,
  } as any)
const restaurantMenuCategoriesCategoryListPageRoute =
  restaurantMenuCategoriesCategoryListPageRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => restaurantMenuMenuLayoutRoute,
  } as any)
const restaurantLogsLogDetailsPageRoute =
  restaurantLogsLogDetailsPageRouteImport.update({
    id: '/logs/$eventId',
    path: '/logs/$eventId',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantCustomersCustomerDetailsPageRoute =
  restaurantCustomersCustomerDetailsPageRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const adminStandalonePrintersStandalonePrinterEmulatorPageRoute =
  adminStandalonePrintersStandalonePrinterEmulatorPageRouteImport.update({
    id: '/standalone-printers/$imei/emulator',
    path: '/standalone-printers/$imei/emulator',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminLinklyLinklySessionDetailsPageRoute =
  adminLinklyLinklySessionDetailsPageRouteImport.update({
    id: '/linkly/sessions/$sessionUuid',
    path: '/linkly/sessions/$sessionUuid',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminLinklyLinklyRequestDetailsPageRoute =
  adminLinklyLinklyRequestDetailsPageRouteImport.update({
    id: '/linkly/requests/$id',
    path: '/linkly/requests/$id',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const adminLinklyLinklyDeviceDetailsPageRoute =
  adminLinklyLinklyDeviceDetailsPageRouteImport.update({
    id: '/linkly/devices/$linklyDeviceId',
    path: '/linkly/devices/$linklyDeviceId',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const restaurantPhoneCallsPhoneCallListPageRoute =
  restaurantPhoneCallsPhoneCallListPageRouteImport.update({
    id: '/phone-calls/',
    path: '/phone-calls/',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantOrdersOrderListPageRoute =
  restaurantOrdersOrderListPageRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantLogsLogListPageRoute =
  restaurantLogsLogListPageRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const restaurantCustomersCustomerListPageRoute =
  restaurantCustomersCustomerListPageRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => restaurantRestaurantLayoutRoute,
  } as any)
const adminLinklyLinklyDeviceListPageRoute =
  adminLinklyLinklyDeviceListPageRouteImport.update({
    id: '/linkly/devices/',
    path: '/linkly/devices/',
    getParentRoute: () => adminAdminLayoutRoute,
  } as any)
const restaurantSettingsIpadsIPadDetailsPageRoute =
  restaurantSettingsIpadsIPadDetailsPageRouteImport.update({
    id: '/ipads/$deviceId',
    path: '/ipads/$deviceId',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)
const restaurantMenuMenuVersionsMenuVersionListPageRoute =
  restaurantMenuMenuVersionsMenuVersionListPageRouteImport.update({
    id: '/$menuId/versions',
    path: '/$menuId/versions',
    getParentRoute: () => restaurantMenuMenuLayoutRoute,
  } as any)
const restaurantSettingsIpadsIPadListPageRoute =
  restaurantSettingsIpadsIPadListPageRouteImport.update({
    id: '/ipads/',
    path: '/ipads/',
    getParentRoute: () => restaurantSettingsSettingsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof RootRedirectRoute
  '/a': typeof adminAdminLayoutRouteWithChildren
  '/connect-agent': typeof connectAgentConnectAgentPageRoute
  '/r': typeof restaurantRestaurantShellLayoutRouteWithChildren
  '/a/': typeof adminAdminRootRedirectRoute
  '/r/': typeof restaurantSelectRestaurantPageRoute
  '/a/app-updates': typeof adminAppUpdatesAppUpdatesPageRoute
  '/a/conversations': typeof adminConversationsConversationsLayoutRouteWithChildren
  '/a/feature-flags': typeof adminFeatureFlagsFeatureFlagListPageRoute
  '/a/phone-calls': typeof adminPhoneCallsAdminPhoneCallListPageRoute
  '/a/restaurants': typeof adminRestaurantsRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionDiffPageRoute
  '/r/$restaurantId': typeof restaurantRestaurantLayoutRouteWithChildren
  '/a/articles/': typeof adminArticlesArticleListPageRoute
  '/a/conversations/': typeof adminConversationsConversationListPageRoute
  '/a/ipads/': typeof adminIpadsAdminIPadListPageRoute
  '/a/logs/': typeof adminLogsAdminLogListPageRoute
  '/a/orders/': typeof adminOrdersAdminOrderListPageRoute
  '/a/push-notifications/': typeof adminPushNotificationsPushNotificationListPageRoute
  '/a/remote-commands/': typeof adminRemoteCommandsRemoteCommandListPageRoute
  '/a/standalone-printers/': typeof adminStandalonePrintersStandalonePrinterListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsAdminIPadDetailsPageRoute
  '/a/logs/$eventId': typeof adminLogsAdminLogDetailsPageRoute
  '/a/orders/$orderUuid': typeof adminOrdersAdminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationsPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandsRemoteCommandDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsSettingsLayoutRouteWithChildren
  '/a/linkly/devices/': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers/': typeof restaurantCustomersCustomerListPageRoute
  '/r/$restaurantId/logs/': typeof restaurantLogsLogListPageRoute
  '/r/$restaurantId/orders/': typeof restaurantOrdersOrderListPageRoute
  '/r/$restaurantId/phone-calls/': typeof restaurantPhoneCallsPhoneCallListPageRoute
  '/a/linkly/devices/$linklyDeviceId': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersStandalonePrinterEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomersCustomerDetailsPageRoute
  '/r/$restaurantId/logs/$eventId': typeof restaurantLogsLogDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoriesCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemsMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifiersModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderUuid': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/phone-calls/$callId': typeof restaurantPhoneCallsPhoneCallDetailsPageRoute
  '/r/$restaurantId/s/ai-agents': typeof restaurantSettingsAiAgentsAiAgentsPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodeListPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsFeatureFlagsPageRoute
  '/r/$restaurantId/s/features': typeof restaurantSettingsFeaturesFeaturesPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigMobileAppConfigPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-price-adjustments': typeof restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursServiceHoursPageRoute
  '/r/$restaurantId/s/square': typeof restaurantSettingsIntegrationsSquareSquarePageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripeStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUsersRestaurantUserListPageRoute
  '/r/$restaurantId/s/website-address': typeof restaurantSettingsWebsiteAddressWebsiteAddressPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigWebsiteConfigPageRoute
  '/r/$restaurantId/s/ipads/': typeof restaurantSettingsIpadsIPadListPageRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionsMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRoutesByTo {
  '/': typeof RootRedirectRoute
  '/connect-agent': typeof connectAgentConnectAgentPageRoute
  '/a': typeof adminAdminRootRedirectRoute
  '/r': typeof restaurantSelectRestaurantPageRoute
  '/a/app-updates': typeof adminAppUpdatesAppUpdatesPageRoute
  '/a/feature-flags': typeof adminFeatureFlagsFeatureFlagListPageRoute
  '/a/phone-calls': typeof adminPhoneCallsAdminPhoneCallListPageRoute
  '/a/restaurants': typeof adminRestaurantsRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionDiffPageRoute
  '/r/$restaurantId': typeof restaurantRestaurantLayoutRouteWithChildren
  '/a/articles': typeof adminArticlesArticleListPageRoute
  '/a/conversations': typeof adminConversationsConversationListPageRoute
  '/a/ipads': typeof adminIpadsAdminIPadListPageRoute
  '/a/logs': typeof adminLogsAdminLogListPageRoute
  '/a/orders': typeof adminOrdersAdminOrderListPageRoute
  '/a/push-notifications': typeof adminPushNotificationsPushNotificationListPageRoute
  '/a/remote-commands': typeof adminRemoteCommandsRemoteCommandListPageRoute
  '/a/standalone-printers': typeof adminStandalonePrintersStandalonePrinterListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsAdminIPadDetailsPageRoute
  '/a/logs/$eventId': typeof adminLogsAdminLogDetailsPageRoute
  '/a/orders/$orderUuid': typeof adminOrdersAdminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationsPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandsRemoteCommandDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsSettingsLayoutRouteWithChildren
  '/a/linkly/devices': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers': typeof restaurantCustomersCustomerListPageRoute
  '/r/$restaurantId/logs': typeof restaurantLogsLogListPageRoute
  '/r/$restaurantId/orders': typeof restaurantOrdersOrderListPageRoute
  '/r/$restaurantId/phone-calls': typeof restaurantPhoneCallsPhoneCallListPageRoute
  '/a/linkly/devices/$linklyDeviceId': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersStandalonePrinterEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomersCustomerDetailsPageRoute
  '/r/$restaurantId/logs/$eventId': typeof restaurantLogsLogDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoriesCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemsMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifiersModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderUuid': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/phone-calls/$callId': typeof restaurantPhoneCallsPhoneCallDetailsPageRoute
  '/r/$restaurantId/s/ai-agents': typeof restaurantSettingsAiAgentsAiAgentsPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodeListPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsFeatureFlagsPageRoute
  '/r/$restaurantId/s/features': typeof restaurantSettingsFeaturesFeaturesPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigMobileAppConfigPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-price-adjustments': typeof restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursServiceHoursPageRoute
  '/r/$restaurantId/s/square': typeof restaurantSettingsIntegrationsSquareSquarePageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripeStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUsersRestaurantUserListPageRoute
  '/r/$restaurantId/s/website-address': typeof restaurantSettingsWebsiteAddressWebsiteAddressPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigWebsiteConfigPageRoute
  '/r/$restaurantId/s/ipads': typeof restaurantSettingsIpadsIPadListPageRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionsMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof RootRedirectRoute
  '/a': typeof adminAdminLayoutRouteWithChildren
  '/connect-agent': typeof connectAgentConnectAgentPageRoute
  '/r': typeof restaurantRestaurantShellLayoutRouteWithChildren
  '/a/': typeof adminAdminRootRedirectRoute
  '/r/': typeof restaurantSelectRestaurantPageRoute
  '/a/app-updates': typeof adminAppUpdatesAppUpdatesPageRoute
  '/a/conversations': typeof adminConversationsConversationsLayoutRouteWithChildren
  '/a/feature-flags': typeof adminFeatureFlagsFeatureFlagListPageRoute
  '/a/phone-calls': typeof adminPhoneCallsAdminPhoneCallListPageRoute
  '/a/restaurants': typeof adminRestaurantsRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionDiffPageRoute
  '/r/$restaurantId': typeof restaurantRestaurantLayoutRouteWithChildren
  '/a/articles/': typeof adminArticlesArticleListPageRoute
  '/a/conversations/': typeof adminConversationsConversationListPageRoute
  '/a/ipads/': typeof adminIpadsAdminIPadListPageRoute
  '/a/logs/': typeof adminLogsAdminLogListPageRoute
  '/a/orders/': typeof adminOrdersAdminOrderListPageRoute
  '/a/push-notifications/': typeof adminPushNotificationsPushNotificationListPageRoute
  '/a/remote-commands/': typeof adminRemoteCommandsRemoteCommandListPageRoute
  '/a/standalone-printers/': typeof adminStandalonePrintersStandalonePrinterListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsAdminIPadDetailsPageRoute
  '/a/logs/$eventId': typeof adminLogsAdminLogDetailsPageRoute
  '/a/orders/$orderUuid': typeof adminOrdersAdminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationsPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandsRemoteCommandDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsSettingsLayoutRouteWithChildren
  '/a/linkly/devices/': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers/': typeof restaurantCustomersCustomerListPageRoute
  '/r/$restaurantId/logs/': typeof restaurantLogsLogListPageRoute
  '/r/$restaurantId/orders/': typeof restaurantOrdersOrderListPageRoute
  '/r/$restaurantId/phone-calls/': typeof restaurantPhoneCallsPhoneCallListPageRoute
  '/a/linkly/devices/$linklyDeviceId': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersStandalonePrinterEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomersCustomerDetailsPageRoute
  '/r/$restaurantId/logs/$eventId': typeof restaurantLogsLogDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoriesCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemsMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifiersModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderUuid': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/phone-calls/$callId': typeof restaurantPhoneCallsPhoneCallDetailsPageRoute
  '/r/$restaurantId/s/ai-agents': typeof restaurantSettingsAiAgentsAiAgentsPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodeListPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsFeatureFlagsPageRoute
  '/r/$restaurantId/s/features': typeof restaurantSettingsFeaturesFeaturesPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigMobileAppConfigPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-price-adjustments': typeof restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursServiceHoursPageRoute
  '/r/$restaurantId/s/square': typeof restaurantSettingsIntegrationsSquareSquarePageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripeStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUsersRestaurantUserListPageRoute
  '/r/$restaurantId/s/website-address': typeof restaurantSettingsWebsiteAddressWebsiteAddressPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigWebsiteConfigPageRoute
  '/r/$restaurantId/s/ipads/': typeof restaurantSettingsIpadsIPadListPageRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionsMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a'
    | '/connect-agent'
    | '/r'
    | '/a/'
    | '/r/'
    | '/a/app-updates'
    | '/a/conversations'
    | '/a/feature-flags'
    | '/a/phone-calls'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles/'
    | '/a/conversations/'
    | '/a/ipads/'
    | '/a/logs/'
    | '/a/orders/'
    | '/a/push-notifications/'
    | '/a/remote-commands/'
    | '/a/standalone-printers/'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/logs/$eventId'
    | '/a/orders/$orderUuid'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices/'
    | '/r/$restaurantId/customers/'
    | '/r/$restaurantId/logs/'
    | '/r/$restaurantId/orders/'
    | '/r/$restaurantId/phone-calls/'
    | '/a/linkly/devices/$linklyDeviceId'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/logs/$eventId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderUuid'
    | '/r/$restaurantId/phone-calls/$callId'
    | '/r/$restaurantId/s/ai-agents'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/features'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-price-adjustments'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/square'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-address'
    | '/r/$restaurantId/s/website-config'
    | '/r/$restaurantId/s/ipads/'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect-agent'
    | '/a'
    | '/r'
    | '/a/app-updates'
    | '/a/feature-flags'
    | '/a/phone-calls'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles'
    | '/a/conversations'
    | '/a/ipads'
    | '/a/logs'
    | '/a/orders'
    | '/a/push-notifications'
    | '/a/remote-commands'
    | '/a/standalone-printers'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/logs/$eventId'
    | '/a/orders/$orderUuid'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices'
    | '/r/$restaurantId/customers'
    | '/r/$restaurantId/logs'
    | '/r/$restaurantId/orders'
    | '/r/$restaurantId/phone-calls'
    | '/a/linkly/devices/$linklyDeviceId'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/logs/$eventId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderUuid'
    | '/r/$restaurantId/phone-calls/$callId'
    | '/r/$restaurantId/s/ai-agents'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/features'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-price-adjustments'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/square'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-address'
    | '/r/$restaurantId/s/website-config'
    | '/r/$restaurantId/s/ipads'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  id:
    | '__root__'
    | '/'
    | '/a'
    | '/connect-agent'
    | '/r'
    | '/a/'
    | '/r/'
    | '/a/app-updates'
    | '/a/conversations'
    | '/a/feature-flags'
    | '/a/phone-calls'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles/'
    | '/a/conversations/'
    | '/a/ipads/'
    | '/a/logs/'
    | '/a/orders/'
    | '/a/push-notifications/'
    | '/a/remote-commands/'
    | '/a/standalone-printers/'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/logs/$eventId'
    | '/a/orders/$orderUuid'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices/'
    | '/r/$restaurantId/customers/'
    | '/r/$restaurantId/logs/'
    | '/r/$restaurantId/orders/'
    | '/r/$restaurantId/phone-calls/'
    | '/a/linkly/devices/$linklyDeviceId'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/logs/$eventId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderUuid'
    | '/r/$restaurantId/phone-calls/$callId'
    | '/r/$restaurantId/s/ai-agents'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/features'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-price-adjustments'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/square'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-address'
    | '/r/$restaurantId/s/website-config'
    | '/r/$restaurantId/s/ipads/'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  RootRedirectRoute: typeof RootRedirectRoute
  adminAdminLayoutRoute: typeof adminAdminLayoutRouteWithChildren
  connectAgentConnectAgentPageRoute: typeof connectAgentConnectAgentPageRoute
  restaurantRestaurantShellLayoutRoute: typeof restaurantRestaurantShellLayoutRouteWithChildren
  MenuVersionDiffPageRoute: typeof MenuVersionDiffPageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/r': {
      id: '/r'
      path: '/r'
      fullPath: '/r'
      preLoaderRoute: typeof restaurantRestaurantShellLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect-agent': {
      id: '/connect-agent'
      path: '/connect-agent'
      fullPath: '/connect-agent'
      preLoaderRoute: typeof connectAgentConnectAgentPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a': {
      id: '/a'
      path: '/a'
      fullPath: '/a'
      preLoaderRoute: typeof adminAdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RootRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$restaurantId': {
      id: '/r/$restaurantId'
      path: '/$restaurantId'
      fullPath: '/r/$restaurantId'
      preLoaderRoute: typeof restaurantRestaurantLayoutRouteImport
      parentRoute: typeof restaurantRestaurantShellLayoutRoute
    }
    '/menu-versions/$menuVersionId': {
      id: '/menu-versions/$menuVersionId'
      path: '/menu-versions/$menuVersionId'
      fullPath: '/menu-versions/$menuVersionId'
      preLoaderRoute: typeof MenuVersionDiffPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/restaurants': {
      id: '/a/restaurants'
      path: '/restaurants'
      fullPath: '/a/restaurants'
      preLoaderRoute: typeof adminRestaurantsRestaurantListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/phone-calls': {
      id: '/a/phone-calls'
      path: '/phone-calls'
      fullPath: '/a/phone-calls'
      preLoaderRoute: typeof adminPhoneCallsAdminPhoneCallListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/feature-flags': {
      id: '/a/feature-flags'
      path: '/feature-flags'
      fullPath: '/a/feature-flags'
      preLoaderRoute: typeof adminFeatureFlagsFeatureFlagListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/conversations': {
      id: '/a/conversations'
      path: '/conversations'
      fullPath: '/a/conversations'
      preLoaderRoute: typeof adminConversationsConversationsLayoutRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/app-updates': {
      id: '/a/app-updates'
      path: '/app-updates'
      fullPath: '/a/app-updates'
      preLoaderRoute: typeof adminAppUpdatesAppUpdatesPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/r/': {
      id: '/r/'
      path: '/'
      fullPath: '/r/'
      preLoaderRoute: typeof restaurantSelectRestaurantPageRouteImport
      parentRoute: typeof restaurantRestaurantShellLayoutRoute
    }
    '/a/': {
      id: '/a/'
      path: '/'
      fullPath: '/a/'
      preLoaderRoute: typeof adminAdminRootRedirectRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/r/$restaurantId/s': {
      id: '/r/$restaurantId/s'
      path: '/s'
      fullPath: '/r/$restaurantId/s'
      preLoaderRoute: typeof restaurantSettingsSettingsLayoutRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/register-closures': {
      id: '/r/$restaurantId/register-closures'
      path: '/register-closures'
      fullPath: '/r/$restaurantId/register-closures'
      preLoaderRoute: typeof restaurantRegisterClosuresRegisterClosuresPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/print-jobs': {
      id: '/r/$restaurantId/print-jobs'
      path: '/print-jobs'
      fullPath: '/r/$restaurantId/print-jobs'
      preLoaderRoute: typeof restaurantPrintJobsPrintJobsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/menu': {
      id: '/r/$restaurantId/menu'
      path: '/menu'
      fullPath: '/r/$restaurantId/menu'
      preLoaderRoute: typeof restaurantMenuMenuLayoutRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/day-reports': {
      id: '/r/$restaurantId/day-reports'
      path: '/day-reports'
      fullPath: '/r/$restaurantId/day-reports'
      preLoaderRoute: typeof restaurantDayReportsDayReportsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/a/remote-commands/$commandId': {
      id: '/a/remote-commands/$commandId'
      path: '/remote-commands/$commandId'
      fullPath: '/a/remote-commands/$commandId'
      preLoaderRoute: typeof adminRemoteCommandsRemoteCommandDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/push-notifications/$notificationId': {
      id: '/a/push-notifications/$notificationId'
      path: '/push-notifications/$notificationId'
      fullPath: '/a/push-notifications/$notificationId'
      preLoaderRoute: typeof adminPushNotificationsPushNotificationDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/orders/$orderUuid': {
      id: '/a/orders/$orderUuid'
      path: '/orders/$orderUuid'
      fullPath: '/a/orders/$orderUuid'
      preLoaderRoute: typeof adminOrdersAdminOrderDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/logs/$eventId': {
      id: '/a/logs/$eventId'
      path: '/logs/$eventId'
      fullPath: '/a/logs/$eventId'
      preLoaderRoute: typeof adminLogsAdminLogDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/ipads/$deviceId': {
      id: '/a/ipads/$deviceId'
      path: '/ipads/$deviceId'
      fullPath: '/a/ipads/$deviceId'
      preLoaderRoute: typeof adminIpadsAdminIPadDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/conversations/$conversationId': {
      id: '/a/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/a/conversations/$conversationId'
      preLoaderRoute: typeof adminConversationsConversationDetailsPageRouteImport
      parentRoute: typeof adminConversationsConversationsLayoutRoute
    }
    '/a/articles/$articleId': {
      id: '/a/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/a/articles/$articleId'
      preLoaderRoute: typeof adminArticlesArticleEditPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/standalone-printers/': {
      id: '/a/standalone-printers/'
      path: '/standalone-printers'
      fullPath: '/a/standalone-printers/'
      preLoaderRoute: typeof adminStandalonePrintersStandalonePrinterListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/remote-commands/': {
      id: '/a/remote-commands/'
      path: '/remote-commands'
      fullPath: '/a/remote-commands/'
      preLoaderRoute: typeof adminRemoteCommandsRemoteCommandListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/push-notifications/': {
      id: '/a/push-notifications/'
      path: '/push-notifications'
      fullPath: '/a/push-notifications/'
      preLoaderRoute: typeof adminPushNotificationsPushNotificationListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/orders/': {
      id: '/a/orders/'
      path: '/orders'
      fullPath: '/a/orders/'
      preLoaderRoute: typeof adminOrdersAdminOrderListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/logs/': {
      id: '/a/logs/'
      path: '/logs'
      fullPath: '/a/logs/'
      preLoaderRoute: typeof adminLogsAdminLogListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/ipads/': {
      id: '/a/ipads/'
      path: '/ipads'
      fullPath: '/a/ipads/'
      preLoaderRoute: typeof adminIpadsAdminIPadListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/conversations/': {
      id: '/a/conversations/'
      path: '/'
      fullPath: '/a/conversations/'
      preLoaderRoute: typeof adminConversationsConversationListPageRouteImport
      parentRoute: typeof adminConversationsConversationsLayoutRoute
    }
    '/a/articles/': {
      id: '/a/articles/'
      path: '/articles'
      fullPath: '/a/articles/'
      preLoaderRoute: typeof adminArticlesArticleListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/r/$restaurantId/s/website-config': {
      id: '/r/$restaurantId/s/website-config'
      path: '/website-config'
      fullPath: '/r/$restaurantId/s/website-config'
      preLoaderRoute: typeof restaurantSettingsWebsiteConfigWebsiteConfigPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/website-address': {
      id: '/r/$restaurantId/s/website-address'
      path: '/website-address'
      fullPath: '/r/$restaurantId/s/website-address'
      preLoaderRoute: typeof restaurantSettingsWebsiteAddressWebsiteAddressPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/users': {
      id: '/r/$restaurantId/s/users'
      path: '/users'
      fullPath: '/r/$restaurantId/s/users'
      preLoaderRoute: typeof restaurantSettingsUsersRestaurantUserListPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/stripe': {
      id: '/r/$restaurantId/s/stripe'
      path: '/stripe'
      fullPath: '/r/$restaurantId/s/stripe'
      preLoaderRoute: typeof restaurantSettingsStripeStripePageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/square': {
      id: '/r/$restaurantId/s/square'
      path: '/square'
      fullPath: '/r/$restaurantId/s/square'
      preLoaderRoute: typeof restaurantSettingsIntegrationsSquareSquarePageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/service-hours': {
      id: '/r/$restaurantId/s/service-hours'
      path: '/service-hours'
      fullPath: '/r/$restaurantId/s/service-hours'
      preLoaderRoute: typeof restaurantSettingsServiceHoursServiceHoursPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/pos-printers': {
      id: '/r/$restaurantId/s/pos-printers'
      path: '/pos-printers'
      fullPath: '/r/$restaurantId/s/pos-printers'
      preLoaderRoute: typeof restaurantSettingsPosPrintersPosPrintersPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/pos-price-adjustments': {
      id: '/r/$restaurantId/s/pos-price-adjustments'
      path: '/pos-price-adjustments'
      fullPath: '/r/$restaurantId/s/pos-price-adjustments'
      preLoaderRoute: typeof restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/pos-passcodes': {
      id: '/r/$restaurantId/s/pos-passcodes'
      path: '/pos-passcodes'
      fullPath: '/r/$restaurantId/s/pos-passcodes'
      preLoaderRoute: typeof restaurantSettingsPosPasscodesPosPasscodesPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/platform-settings': {
      id: '/r/$restaurantId/s/platform-settings'
      path: '/platform-settings'
      fullPath: '/r/$restaurantId/s/platform-settings'
      preLoaderRoute: typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/mobile-app-config': {
      id: '/r/$restaurantId/s/mobile-app-config'
      path: '/mobile-app-config'
      fullPath: '/r/$restaurantId/s/mobile-app-config'
      preLoaderRoute: typeof restaurantSettingsMobileAppConfigMobileAppConfigPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/loyalty-card': {
      id: '/r/$restaurantId/s/loyalty-card'
      path: '/loyalty-card'
      fullPath: '/r/$restaurantId/s/loyalty-card'
      preLoaderRoute: typeof restaurantSettingsLoyaltyCardLoyaltyCardPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/general-settings': {
      id: '/r/$restaurantId/s/general-settings'
      path: '/general-settings'
      fullPath: '/r/$restaurantId/s/general-settings'
      preLoaderRoute: typeof restaurantSettingsGeneralSettingsGeneralSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/floor-plans': {
      id: '/r/$restaurantId/s/floor-plans'
      path: '/floor-plans'
      fullPath: '/r/$restaurantId/s/floor-plans'
      preLoaderRoute: typeof restaurantSettingsFloorPlansFloorPlansPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/features': {
      id: '/r/$restaurantId/s/features'
      path: '/features'
      fullPath: '/r/$restaurantId/s/features'
      preLoaderRoute: typeof restaurantSettingsFeaturesFeaturesPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/feature-flags': {
      id: '/r/$restaurantId/s/feature-flags'
      path: '/feature-flags'
      fullPath: '/r/$restaurantId/s/feature-flags'
      preLoaderRoute: typeof restaurantSettingsFeatureFlagsFeatureFlagsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/discount-codes': {
      id: '/r/$restaurantId/s/discount-codes'
      path: '/discount-codes'
      fullPath: '/r/$restaurantId/s/discount-codes'
      preLoaderRoute: typeof restaurantSettingsDiscountCodesDiscountCodeListPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/delivery': {
      id: '/r/$restaurantId/s/delivery'
      path: '/delivery'
      fullPath: '/r/$restaurantId/s/delivery'
      preLoaderRoute: typeof restaurantSettingsDeliveryDeliveryPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/s/ai-agents': {
      id: '/r/$restaurantId/s/ai-agents'
      path: '/ai-agents'
      fullPath: '/r/$restaurantId/s/ai-agents'
      preLoaderRoute: typeof restaurantSettingsAiAgentsAiAgentsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/phone-calls/$callId': {
      id: '/r/$restaurantId/phone-calls/$callId'
      path: '/phone-calls/$callId'
      fullPath: '/r/$restaurantId/phone-calls/$callId'
      preLoaderRoute: typeof restaurantPhoneCallsPhoneCallDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/orders/$orderUuid': {
      id: '/r/$restaurantId/orders/$orderUuid'
      path: '/orders/$orderUuid'
      fullPath: '/r/$restaurantId/orders/$orderUuid'
      preLoaderRoute: typeof restaurantOrdersOrderDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/menu/overview': {
      id: '/r/$restaurantId/menu/overview'
      path: '/overview'
      fullPath: '/r/$restaurantId/menu/overview'
      preLoaderRoute: typeof restaurantMenuOverviewMenuOverviewPageRouteImport
      parentRoute: typeof restaurantMenuMenuLayoutRoute
    }
    '/r/$restaurantId/menu/modifiers': {
      id: '/r/$restaurantId/menu/modifiers'
      path: '/modifiers'
      fullPath: '/r/$restaurantId/menu/modifiers'
      preLoaderRoute: typeof restaurantMenuModifiersModifierListPageRouteImport
      parentRoute: typeof restaurantMenuMenuLayoutRoute
    }
    '/r/$restaurantId/menu/menu-items': {
      id: '/r/$restaurantId/menu/menu-items'
      path: '/menu-items'
      fullPath: '/r/$restaurantId/menu/menu-items'
      preLoaderRoute: typeof restaurantMenuMenuItemsMenuItemListPageRouteImport
      parentRoute: typeof restaurantMenuMenuLayoutRoute
    }
    '/r/$restaurantId/menu/categories': {
      id: '/r/$restaurantId/menu/categories'
      path: '/categories'
      fullPath: '/r/$restaurantId/menu/categories'
      preLoaderRoute: typeof restaurantMenuCategoriesCategoryListPageRouteImport
      parentRoute: typeof restaurantMenuMenuLayoutRoute
    }
    '/r/$restaurantId/logs/$eventId': {
      id: '/r/$restaurantId/logs/$eventId'
      path: '/logs/$eventId'
      fullPath: '/r/$restaurantId/logs/$eventId'
      preLoaderRoute: typeof restaurantLogsLogDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/customers/$customerId': {
      id: '/r/$restaurantId/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/r/$restaurantId/customers/$customerId'
      preLoaderRoute: typeof restaurantCustomersCustomerDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/a/standalone-printers/$imei/emulator': {
      id: '/a/standalone-printers/$imei/emulator'
      path: '/standalone-printers/$imei/emulator'
      fullPath: '/a/standalone-printers/$imei/emulator'
      preLoaderRoute: typeof adminStandalonePrintersStandalonePrinterEmulatorPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/linkly/sessions/$sessionUuid': {
      id: '/a/linkly/sessions/$sessionUuid'
      path: '/linkly/sessions/$sessionUuid'
      fullPath: '/a/linkly/sessions/$sessionUuid'
      preLoaderRoute: typeof adminLinklyLinklySessionDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/linkly/requests/$id': {
      id: '/a/linkly/requests/$id'
      path: '/linkly/requests/$id'
      fullPath: '/a/linkly/requests/$id'
      preLoaderRoute: typeof adminLinklyLinklyRequestDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/a/linkly/devices/$linklyDeviceId': {
      id: '/a/linkly/devices/$linklyDeviceId'
      path: '/linkly/devices/$linklyDeviceId'
      fullPath: '/a/linkly/devices/$linklyDeviceId'
      preLoaderRoute: typeof adminLinklyLinklyDeviceDetailsPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/r/$restaurantId/phone-calls/': {
      id: '/r/$restaurantId/phone-calls/'
      path: '/phone-calls'
      fullPath: '/r/$restaurantId/phone-calls/'
      preLoaderRoute: typeof restaurantPhoneCallsPhoneCallListPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/orders/': {
      id: '/r/$restaurantId/orders/'
      path: '/orders'
      fullPath: '/r/$restaurantId/orders/'
      preLoaderRoute: typeof restaurantOrdersOrderListPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/logs/': {
      id: '/r/$restaurantId/logs/'
      path: '/logs'
      fullPath: '/r/$restaurantId/logs/'
      preLoaderRoute: typeof restaurantLogsLogListPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/r/$restaurantId/customers/': {
      id: '/r/$restaurantId/customers/'
      path: '/customers'
      fullPath: '/r/$restaurantId/customers/'
      preLoaderRoute: typeof restaurantCustomersCustomerListPageRouteImport
      parentRoute: typeof restaurantRestaurantLayoutRoute
    }
    '/a/linkly/devices/': {
      id: '/a/linkly/devices/'
      path: '/linkly/devices'
      fullPath: '/a/linkly/devices/'
      preLoaderRoute: typeof adminLinklyLinklyDeviceListPageRouteImport
      parentRoute: typeof adminAdminLayoutRoute
    }
    '/r/$restaurantId/s/ipads/$deviceId': {
      id: '/r/$restaurantId/s/ipads/$deviceId'
      path: '/ipads/$deviceId'
      fullPath: '/r/$restaurantId/s/ipads/$deviceId'
      preLoaderRoute: typeof restaurantSettingsIpadsIPadDetailsPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
    '/r/$restaurantId/menu/$menuId/versions': {
      id: '/r/$restaurantId/menu/$menuId/versions'
      path: '/$menuId/versions'
      fullPath: '/r/$restaurantId/menu/$menuId/versions'
      preLoaderRoute: typeof restaurantMenuMenuVersionsMenuVersionListPageRouteImport
      parentRoute: typeof restaurantMenuMenuLayoutRoute
    }
    '/r/$restaurantId/s/ipads/': {
      id: '/r/$restaurantId/s/ipads/'
      path: '/ipads'
      fullPath: '/r/$restaurantId/s/ipads/'
      preLoaderRoute: typeof restaurantSettingsIpadsIPadListPageRouteImport
      parentRoute: typeof restaurantSettingsSettingsLayoutRoute
    }
  }
}

interface adminConversationsConversationsLayoutRouteChildren {
  adminConversationsConversationListPageRoute: typeof adminConversationsConversationListPageRoute
  adminConversationsConversationDetailsPageRoute: typeof adminConversationsConversationDetailsPageRoute
}

const adminConversationsConversationsLayoutRouteChildren: adminConversationsConversationsLayoutRouteChildren =
  {
    adminConversationsConversationListPageRoute:
      adminConversationsConversationListPageRoute,
    adminConversationsConversationDetailsPageRoute:
      adminConversationsConversationDetailsPageRoute,
  }

const adminConversationsConversationsLayoutRouteWithChildren =
  adminConversationsConversationsLayoutRoute._addFileChildren(
    adminConversationsConversationsLayoutRouteChildren,
  )

interface adminAdminLayoutRouteChildren {
  adminAdminRootRedirectRoute: typeof adminAdminRootRedirectRoute
  adminAppUpdatesAppUpdatesPageRoute: typeof adminAppUpdatesAppUpdatesPageRoute
  adminConversationsConversationsLayoutRoute: typeof adminConversationsConversationsLayoutRouteWithChildren
  adminFeatureFlagsFeatureFlagListPageRoute: typeof adminFeatureFlagsFeatureFlagListPageRoute
  adminPhoneCallsAdminPhoneCallListPageRoute: typeof adminPhoneCallsAdminPhoneCallListPageRoute
  adminRestaurantsRestaurantListPageRoute: typeof adminRestaurantsRestaurantListPageRoute
  adminArticlesArticleListPageRoute: typeof adminArticlesArticleListPageRoute
  adminIpadsAdminIPadListPageRoute: typeof adminIpadsAdminIPadListPageRoute
  adminLogsAdminLogListPageRoute: typeof adminLogsAdminLogListPageRoute
  adminOrdersAdminOrderListPageRoute: typeof adminOrdersAdminOrderListPageRoute
  adminPushNotificationsPushNotificationListPageRoute: typeof adminPushNotificationsPushNotificationListPageRoute
  adminRemoteCommandsRemoteCommandListPageRoute: typeof adminRemoteCommandsRemoteCommandListPageRoute
  adminStandalonePrintersStandalonePrinterListPageRoute: typeof adminStandalonePrintersStandalonePrinterListPageRoute
  adminArticlesArticleEditPageRoute: typeof adminArticlesArticleEditPageRoute
  adminIpadsAdminIPadDetailsPageRoute: typeof adminIpadsAdminIPadDetailsPageRoute
  adminLogsAdminLogDetailsPageRoute: typeof adminLogsAdminLogDetailsPageRoute
  adminOrdersAdminOrderDetailsPageRoute: typeof adminOrdersAdminOrderDetailsPageRoute
  adminPushNotificationsPushNotificationDetailsPageRoute: typeof adminPushNotificationsPushNotificationDetailsPageRoute
  adminRemoteCommandsRemoteCommandDetailsPageRoute: typeof adminRemoteCommandsRemoteCommandDetailsPageRoute
  adminLinklyLinklyDeviceListPageRoute: typeof adminLinklyLinklyDeviceListPageRoute
  adminLinklyLinklyDeviceDetailsPageRoute: typeof adminLinklyLinklyDeviceDetailsPageRoute
  adminLinklyLinklyRequestDetailsPageRoute: typeof adminLinklyLinklyRequestDetailsPageRoute
  adminLinklyLinklySessionDetailsPageRoute: typeof adminLinklyLinklySessionDetailsPageRoute
  adminStandalonePrintersStandalonePrinterEmulatorPageRoute: typeof adminStandalonePrintersStandalonePrinterEmulatorPageRoute
}

const adminAdminLayoutRouteChildren: adminAdminLayoutRouteChildren = {
  adminAdminRootRedirectRoute: adminAdminRootRedirectRoute,
  adminAppUpdatesAppUpdatesPageRoute: adminAppUpdatesAppUpdatesPageRoute,
  adminConversationsConversationsLayoutRoute:
    adminConversationsConversationsLayoutRouteWithChildren,
  adminFeatureFlagsFeatureFlagListPageRoute:
    adminFeatureFlagsFeatureFlagListPageRoute,
  adminPhoneCallsAdminPhoneCallListPageRoute:
    adminPhoneCallsAdminPhoneCallListPageRoute,
  adminRestaurantsRestaurantListPageRoute:
    adminRestaurantsRestaurantListPageRoute,
  adminArticlesArticleListPageRoute: adminArticlesArticleListPageRoute,
  adminIpadsAdminIPadListPageRoute: adminIpadsAdminIPadListPageRoute,
  adminLogsAdminLogListPageRoute: adminLogsAdminLogListPageRoute,
  adminOrdersAdminOrderListPageRoute: adminOrdersAdminOrderListPageRoute,
  adminPushNotificationsPushNotificationListPageRoute:
    adminPushNotificationsPushNotificationListPageRoute,
  adminRemoteCommandsRemoteCommandListPageRoute:
    adminRemoteCommandsRemoteCommandListPageRoute,
  adminStandalonePrintersStandalonePrinterListPageRoute:
    adminStandalonePrintersStandalonePrinterListPageRoute,
  adminArticlesArticleEditPageRoute: adminArticlesArticleEditPageRoute,
  adminIpadsAdminIPadDetailsPageRoute: adminIpadsAdminIPadDetailsPageRoute,
  adminLogsAdminLogDetailsPageRoute: adminLogsAdminLogDetailsPageRoute,
  adminOrdersAdminOrderDetailsPageRoute: adminOrdersAdminOrderDetailsPageRoute,
  adminPushNotificationsPushNotificationDetailsPageRoute:
    adminPushNotificationsPushNotificationDetailsPageRoute,
  adminRemoteCommandsRemoteCommandDetailsPageRoute:
    adminRemoteCommandsRemoteCommandDetailsPageRoute,
  adminLinklyLinklyDeviceListPageRoute: adminLinklyLinklyDeviceListPageRoute,
  adminLinklyLinklyDeviceDetailsPageRoute:
    adminLinklyLinklyDeviceDetailsPageRoute,
  adminLinklyLinklyRequestDetailsPageRoute:
    adminLinklyLinklyRequestDetailsPageRoute,
  adminLinklyLinklySessionDetailsPageRoute:
    adminLinklyLinklySessionDetailsPageRoute,
  adminStandalonePrintersStandalonePrinterEmulatorPageRoute:
    adminStandalonePrintersStandalonePrinterEmulatorPageRoute,
}

const adminAdminLayoutRouteWithChildren =
  adminAdminLayoutRoute._addFileChildren(adminAdminLayoutRouteChildren)

interface restaurantMenuMenuLayoutRouteChildren {
  restaurantMenuCategoriesCategoryListPageRoute: typeof restaurantMenuCategoriesCategoryListPageRoute
  restaurantMenuMenuItemsMenuItemListPageRoute: typeof restaurantMenuMenuItemsMenuItemListPageRoute
  restaurantMenuModifiersModifierListPageRoute: typeof restaurantMenuModifiersModifierListPageRoute
  restaurantMenuOverviewMenuOverviewPageRoute: typeof restaurantMenuOverviewMenuOverviewPageRoute
  restaurantMenuMenuVersionsMenuVersionListPageRoute: typeof restaurantMenuMenuVersionsMenuVersionListPageRoute
}

const restaurantMenuMenuLayoutRouteChildren: restaurantMenuMenuLayoutRouteChildren =
  {
    restaurantMenuCategoriesCategoryListPageRoute:
      restaurantMenuCategoriesCategoryListPageRoute,
    restaurantMenuMenuItemsMenuItemListPageRoute:
      restaurantMenuMenuItemsMenuItemListPageRoute,
    restaurantMenuModifiersModifierListPageRoute:
      restaurantMenuModifiersModifierListPageRoute,
    restaurantMenuOverviewMenuOverviewPageRoute:
      restaurantMenuOverviewMenuOverviewPageRoute,
    restaurantMenuMenuVersionsMenuVersionListPageRoute:
      restaurantMenuMenuVersionsMenuVersionListPageRoute,
  }

const restaurantMenuMenuLayoutRouteWithChildren =
  restaurantMenuMenuLayoutRoute._addFileChildren(
    restaurantMenuMenuLayoutRouteChildren,
  )

interface restaurantSettingsSettingsLayoutRouteChildren {
  restaurantSettingsAiAgentsAiAgentsPageRoute: typeof restaurantSettingsAiAgentsAiAgentsPageRoute
  restaurantSettingsDeliveryDeliveryPageRoute: typeof restaurantSettingsDeliveryDeliveryPageRoute
  restaurantSettingsDiscountCodesDiscountCodeListPageRoute: typeof restaurantSettingsDiscountCodesDiscountCodeListPageRoute
  restaurantSettingsFeatureFlagsFeatureFlagsPageRoute: typeof restaurantSettingsFeatureFlagsFeatureFlagsPageRoute
  restaurantSettingsFeaturesFeaturesPageRoute: typeof restaurantSettingsFeaturesFeaturesPageRoute
  restaurantSettingsFloorPlansFloorPlansPageRoute: typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  restaurantSettingsGeneralSettingsGeneralSettingsPageRoute: typeof restaurantSettingsGeneralSettingsGeneralSettingsPageRoute
  restaurantSettingsLoyaltyCardLoyaltyCardPageRoute: typeof restaurantSettingsLoyaltyCardLoyaltyCardPageRoute
  restaurantSettingsMobileAppConfigMobileAppConfigPageRoute: typeof restaurantSettingsMobileAppConfigMobileAppConfigPageRoute
  restaurantSettingsPlatformSettingsPlatformSettingsPageRoute: typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  restaurantSettingsPosPasscodesPosPasscodesPageRoute: typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute: typeof restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute
  restaurantSettingsPosPrintersPosPrintersPageRoute: typeof restaurantSettingsPosPrintersPosPrintersPageRoute
  restaurantSettingsServiceHoursServiceHoursPageRoute: typeof restaurantSettingsServiceHoursServiceHoursPageRoute
  restaurantSettingsIntegrationsSquareSquarePageRoute: typeof restaurantSettingsIntegrationsSquareSquarePageRoute
  restaurantSettingsStripeStripePageRoute: typeof restaurantSettingsStripeStripePageRoute
  restaurantSettingsUsersRestaurantUserListPageRoute: typeof restaurantSettingsUsersRestaurantUserListPageRoute
  restaurantSettingsWebsiteAddressWebsiteAddressPageRoute: typeof restaurantSettingsWebsiteAddressWebsiteAddressPageRoute
  restaurantSettingsWebsiteConfigWebsiteConfigPageRoute: typeof restaurantSettingsWebsiteConfigWebsiteConfigPageRoute
  restaurantSettingsIpadsIPadListPageRoute: typeof restaurantSettingsIpadsIPadListPageRoute
  restaurantSettingsIpadsIPadDetailsPageRoute: typeof restaurantSettingsIpadsIPadDetailsPageRoute
}

const restaurantSettingsSettingsLayoutRouteChildren: restaurantSettingsSettingsLayoutRouteChildren =
  {
    restaurantSettingsAiAgentsAiAgentsPageRoute:
      restaurantSettingsAiAgentsAiAgentsPageRoute,
    restaurantSettingsDeliveryDeliveryPageRoute:
      restaurantSettingsDeliveryDeliveryPageRoute,
    restaurantSettingsDiscountCodesDiscountCodeListPageRoute:
      restaurantSettingsDiscountCodesDiscountCodeListPageRoute,
    restaurantSettingsFeatureFlagsFeatureFlagsPageRoute:
      restaurantSettingsFeatureFlagsFeatureFlagsPageRoute,
    restaurantSettingsFeaturesFeaturesPageRoute:
      restaurantSettingsFeaturesFeaturesPageRoute,
    restaurantSettingsFloorPlansFloorPlansPageRoute:
      restaurantSettingsFloorPlansFloorPlansPageRoute,
    restaurantSettingsGeneralSettingsGeneralSettingsPageRoute:
      restaurantSettingsGeneralSettingsGeneralSettingsPageRoute,
    restaurantSettingsLoyaltyCardLoyaltyCardPageRoute:
      restaurantSettingsLoyaltyCardLoyaltyCardPageRoute,
    restaurantSettingsMobileAppConfigMobileAppConfigPageRoute:
      restaurantSettingsMobileAppConfigMobileAppConfigPageRoute,
    restaurantSettingsPlatformSettingsPlatformSettingsPageRoute:
      restaurantSettingsPlatformSettingsPlatformSettingsPageRoute,
    restaurantSettingsPosPasscodesPosPasscodesPageRoute:
      restaurantSettingsPosPasscodesPosPasscodesPageRoute,
    restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute:
      restaurantSettingsPosPriceAdjustmentsPosPriceAdjustmentsPageRoute,
    restaurantSettingsPosPrintersPosPrintersPageRoute:
      restaurantSettingsPosPrintersPosPrintersPageRoute,
    restaurantSettingsServiceHoursServiceHoursPageRoute:
      restaurantSettingsServiceHoursServiceHoursPageRoute,
    restaurantSettingsIntegrationsSquareSquarePageRoute:
      restaurantSettingsIntegrationsSquareSquarePageRoute,
    restaurantSettingsStripeStripePageRoute:
      restaurantSettingsStripeStripePageRoute,
    restaurantSettingsUsersRestaurantUserListPageRoute:
      restaurantSettingsUsersRestaurantUserListPageRoute,
    restaurantSettingsWebsiteAddressWebsiteAddressPageRoute:
      restaurantSettingsWebsiteAddressWebsiteAddressPageRoute,
    restaurantSettingsWebsiteConfigWebsiteConfigPageRoute:
      restaurantSettingsWebsiteConfigWebsiteConfigPageRoute,
    restaurantSettingsIpadsIPadListPageRoute:
      restaurantSettingsIpadsIPadListPageRoute,
    restaurantSettingsIpadsIPadDetailsPageRoute:
      restaurantSettingsIpadsIPadDetailsPageRoute,
  }

const restaurantSettingsSettingsLayoutRouteWithChildren =
  restaurantSettingsSettingsLayoutRoute._addFileChildren(
    restaurantSettingsSettingsLayoutRouteChildren,
  )

interface restaurantRestaurantLayoutRouteChildren {
  restaurantDayReportsDayReportsPageRoute: typeof restaurantDayReportsDayReportsPageRoute
  restaurantMenuMenuLayoutRoute: typeof restaurantMenuMenuLayoutRouteWithChildren
  restaurantPrintJobsPrintJobsPageRoute: typeof restaurantPrintJobsPrintJobsPageRoute
  restaurantRegisterClosuresRegisterClosuresPageRoute: typeof restaurantRegisterClosuresRegisterClosuresPageRoute
  restaurantSettingsSettingsLayoutRoute: typeof restaurantSettingsSettingsLayoutRouteWithChildren
  restaurantCustomersCustomerListPageRoute: typeof restaurantCustomersCustomerListPageRoute
  restaurantLogsLogListPageRoute: typeof restaurantLogsLogListPageRoute
  restaurantOrdersOrderListPageRoute: typeof restaurantOrdersOrderListPageRoute
  restaurantPhoneCallsPhoneCallListPageRoute: typeof restaurantPhoneCallsPhoneCallListPageRoute
  restaurantCustomersCustomerDetailsPageRoute: typeof restaurantCustomersCustomerDetailsPageRoute
  restaurantLogsLogDetailsPageRoute: typeof restaurantLogsLogDetailsPageRoute
  restaurantOrdersOrderDetailsPageRoute: typeof restaurantOrdersOrderDetailsPageRoute
  restaurantPhoneCallsPhoneCallDetailsPageRoute: typeof restaurantPhoneCallsPhoneCallDetailsPageRoute
}

const restaurantRestaurantLayoutRouteChildren: restaurantRestaurantLayoutRouteChildren =
  {
    restaurantDayReportsDayReportsPageRoute:
      restaurantDayReportsDayReportsPageRoute,
    restaurantMenuMenuLayoutRoute: restaurantMenuMenuLayoutRouteWithChildren,
    restaurantPrintJobsPrintJobsPageRoute:
      restaurantPrintJobsPrintJobsPageRoute,
    restaurantRegisterClosuresRegisterClosuresPageRoute:
      restaurantRegisterClosuresRegisterClosuresPageRoute,
    restaurantSettingsSettingsLayoutRoute:
      restaurantSettingsSettingsLayoutRouteWithChildren,
    restaurantCustomersCustomerListPageRoute:
      restaurantCustomersCustomerListPageRoute,
    restaurantLogsLogListPageRoute: restaurantLogsLogListPageRoute,
    restaurantOrdersOrderListPageRoute: restaurantOrdersOrderListPageRoute,
    restaurantPhoneCallsPhoneCallListPageRoute:
      restaurantPhoneCallsPhoneCallListPageRoute,
    restaurantCustomersCustomerDetailsPageRoute:
      restaurantCustomersCustomerDetailsPageRoute,
    restaurantLogsLogDetailsPageRoute: restaurantLogsLogDetailsPageRoute,
    restaurantOrdersOrderDetailsPageRoute:
      restaurantOrdersOrderDetailsPageRoute,
    restaurantPhoneCallsPhoneCallDetailsPageRoute:
      restaurantPhoneCallsPhoneCallDetailsPageRoute,
  }

const restaurantRestaurantLayoutRouteWithChildren =
  restaurantRestaurantLayoutRoute._addFileChildren(
    restaurantRestaurantLayoutRouteChildren,
  )

interface restaurantRestaurantShellLayoutRouteChildren {
  restaurantSelectRestaurantPageRoute: typeof restaurantSelectRestaurantPageRoute
  restaurantRestaurantLayoutRoute: typeof restaurantRestaurantLayoutRouteWithChildren
}

const restaurantRestaurantShellLayoutRouteChildren: restaurantRestaurantShellLayoutRouteChildren =
  {
    restaurantSelectRestaurantPageRoute: restaurantSelectRestaurantPageRoute,
    restaurantRestaurantLayoutRoute:
      restaurantRestaurantLayoutRouteWithChildren,
  }

const restaurantRestaurantShellLayoutRouteWithChildren =
  restaurantRestaurantShellLayoutRoute._addFileChildren(
    restaurantRestaurantShellLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  RootRedirectRoute: RootRedirectRoute,
  adminAdminLayoutRoute: adminAdminLayoutRouteWithChildren,
  connectAgentConnectAgentPageRoute: connectAgentConnectAgentPageRoute,
  restaurantRestaurantShellLayoutRoute:
    restaurantRestaurantShellLayoutRouteWithChildren,
  MenuVersionDiffPageRoute: MenuVersionDiffPageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
